import { useResponsiveBreakpoints } from './useMediaQuery';

/**
 * Custom hook to get responsive text style based on current breakpoint
 * @param {string} baseStyle - The base/desktop text style
 * @param {boolean} enableResponsive - Whether responsive styles are enabled
 * @param {string} mobileStyle - Mobile-specific text style
 * @param {string} tabletStyle - Tablet-specific text style  
 * @param {string} ultrawideStyle - Ultrawide-specific text style
 * @returns {object} Object containing getCurrentTextStyle function
 */
const useCurrentTextStyle = () => {
  const { isMobile, isTablet, isUltrawide } = useResponsiveBreakpoints();

  const getCurrentTextStyle = (
    baseStyle,
    enableResponsive = false,
    mobileStyle,
    tabletStyle,
    ultrawideStyle
  ) => {
    if (!enableResponsive) return baseStyle;

    if (isMobile && mobileStyle) return mobileStyle;
    if (isTablet && tabletStyle) return tabletStyle;
    if (isUltrawide && ultrawideStyle) return ultrawideStyle;

    return baseStyle;
  };

  return { getCurrentTextStyle };
};

export { useCurrentTextStyle };
export default useCurrentTextStyle;
